import {hitAlgolytics} from "@pg-mono/algolytics";

import {OfferOpinionsFormFields} from "../components/opinions/OfferDetailOpinionsForm";

interface OfferOpinionsTrackingData {
    offer_id?: number;
    property_id?: number;
    site_id: number;
    preferences: {
        standard_preferences: Record<keyof OfferOpinionsFormFields, boolean | string>;
        custom_preferences?: string;
    };
}

export const hitOfferOpinionsTracking = (data: OfferOpinionsTrackingData) => {
    hitAlgolytics("user_preferences_offer_rating", {
        ...data,
        preferences: {
            standard_preferences: getMappedPreferences(data.preferences.standard_preferences),
            custom_preferences: data.preferences.custom_preferences
        }
    });
};

const getMappedPreferences = (preferences: Record<string, boolean | string>): number[] => {
    return Object.entries(preferences)
        .filter(([key, value]) => value == true && fieldMap[key as keyof typeof fieldMap])
        .map(([key]) => {
            return fieldMap[key as keyof typeof fieldMap];
        });
};

const fieldMap: Record<keyof Omit<OfferOpinionsFormFields, "other_reason">, number> = {
    environment_and_infrastructure: 1,
    public_transport_access: 2,
    investment_potential: 3,
    architecture: 4,
    property_layout: 5,
    other_switch: 6
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {OfferOpinionsFormFields} from "../components/opinions/OfferDetailOpinionsForm";

interface OfferOpinionsTrackingData {
    offer_id?: number;
    property_id?: number;
    site_id: number;
    preferences: {
        standard_preferences: Record<keyof OfferOpinionsFormFields, boolean | string>;
        custom_preferences?: string;
    };
}

export const hitOfferOpinionsTracking = (data: OfferOpinionsTrackingData) => {
    hitAlgolytics("user_preferences_offer_rating", {
        ...data,
        preferences: {
            standard_preferences: getMappedPreferences(data.preferences.standard_preferences),
            custom_preferences: data.preferences.custom_preferences
        }
    });
};

const getMappedPreferences = (preferences: Record<string, boolean | string>): number[] => {
    return Object.entries(preferences)
        .filter(([key, value]) => value == true && fieldMap[key as keyof typeof fieldMap])
        .map(([key]) => {
            return fieldMap[key as keyof typeof fieldMap];
        });
};

const fieldMap: Record<keyof Omit<OfferOpinionsFormFields, "other_reason">, number> = {
    environment_and_infrastructure: 1,
    public_transport_access: 2,
    investment_potential: 3,
    architecture: 4,
    property_layout: 5,
    other_switch: 6
};
